'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:closeAll');
}

var _invoke = require('../invoke');
var env = require('../invoke/env');
var versionCompare = require('../invoke/version-compare');

/**
 * 适用的场景是native打开H5的页面选择学校、城市
 *
 * 支持版本
 * + Android
 * + iHotel/6.9+
 *
 * @memberof storage
 * @static
 * @name setResult
 * @param {Object} obj
 * @return {Undefined}
 * @example
 *  hbnb.storage.setResult({id: "45", name: "广西"});
 */
module.exports = function(params) {
    if (process.env.NODE_ENV !== 'production') {
        debug('url list %s', params);
    }

    if (env.platform === 'android' && versionCompare(env.appVersion, '6.9') >= 0) {
        _invoke('inject', 'set_result', params);
    } else {
        // no op
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/storage/set-result.js
// module id = 619
// module chunks = 0